import { createContext, useContext, useEffect, useState } from "react";
import { t as translate } from "@/lib/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("pf_lang") || "ro");

  useEffect(() => {
    localStorage.setItem("pf_lang", lang);
  }, [lang]);

  const t = (key) => translate(lang, key);
  const toggle = () => setLang((l) => (l === "en" ? "ro" : "en"));

  return (
    <LangContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
